<template>
    <div>
        <formulaire-complete
            v-if="complete"
            :noDeLaDemande="codeDemande"
            visible
            :adresseOrganisme="infosOrganisme?.adresseOrganisme"
            :courrielOrganisme="infosOrganisme?.courrielOrganisme"
            :telephoneOrganisme="infosOrganisme?.telephoneOrganisme"
            :siteOrganisme="infosOrganisme?.siteOrganisme"
            :imageLogo="infosOrganisme?.imageLogo" />
        <formulaire-demande v-else :c="c" :no-succursale="noSuccursale" :langue="langue!" @complete="onComplete" />
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'

    import FormulaireComplete from './FormulaireComplete.vue'
    import FormulaireDemande from './FormulaireDemande.vue'

    interface IPropsForm {
        c?: string
        noSuccursale?: string
        langue?: 'fr' | 'en'
    }

    interface IInfosOrganisme {
        adresseOrganisme?: string
        telephoneOrganisme?: string
        courrielOrganisme?: string
        siteOrganisme?: string
        imageLogo?: { extension: string; contenuBase64: string }
    }

    defineProps<IPropsForm>()

    const complete = ref(false)
    const infosOrganisme = ref<IInfosOrganisme>()
    const codeDemande = ref('')

    function onComplete(params: {
        codeDemande: string
        adresseOrganisme?: string
        telephoneOrganisme?: string
        courrielOrganisme?: string
        siteOrganisme?: string
        imageLogo?: { extension: string; contenuBase64: string }
    }) {
        complete.value = true
        codeDemande.value = params.codeDemande
        infosOrganisme.value = {
            adresseOrganisme: params.adresseOrganisme,
            telephoneOrganisme: params.telephoneOrganisme,
            courrielOrganisme: params.courrielOrganisme,
            siteOrganisme: params.siteOrganisme,
            imageLogo: params.imageLogo,
        }
    }
</script>

<style>
    @import '@css/global.less';
</style>
